import config from 'utils/config';

// This checks whether Mindset Coach is configured in the Hub - this is not user specific
// The mindsetAgentUid can be set against the team and empty in config, so we just check for mindsetAppUid.
export var isMindsetEnabledInHub = !!config.mindsetAppUid;